/**
 * Growth info for dynamically growing widgets
 */
export class ReportDesignerWidgetGrowthInfo {
  /**
   * Rows inside the bounds of the widget
   */
  public rowsInBounds: number[] = [];

  /**
   * Rows outside the bounds of the widget
   */
  public rowsOutOfBounds: number[] = [];

  /**
   * Total additional height needed (in px)
   */
  public additionalHeightNeeded = 0;

  /**
   * Row sizes dictionary. Used to determine the space taken up by specific rows. Key: row index. Value: Row height in px
   */
  public rowSizes: any = {};

  /**
   * Does this widget request to be switched to a landscape page if it's alone on a portrait page?
   */
  public moreColumnsRequestedIfOnPortraitPage = false;
}
